<template>
  <div class="container-fixed">
    <h3>Requesting anonymous session</h3>
    <h4>{{ result }}</h4>
  </div>
</template>

<script>
import Proxy from '@/proxies/TestProxy';

export default {
  name: 'TestDate',

  data() {
    return {
      result: null,
    };
  },

  async created() {
    const anonymousData = await new Proxy().anonymous();
    if (anonymousData && anonymousData.result) {
      this.result = anonymousData.result;
    }
  },
};
</script>
